export default "__VITE_ASSET__HGoPhEZZ__"